import React, { ReactNode } from 'react';
import { AudioServicesContext, AudioServicesValue } from './audio-services-context';

type AudioServicesProviderProps = {
  /** Implementaciones concretas (HTTP, mock, etc.) que el editor usará. */
  value: AudioServicesValue;
  children: ReactNode;
};

/**
 * Provider externo: el consumer wrappea el editor y le inyecta cómo hablar
 * con su backend para audio. Mantiene la librería platform-agnostic.
 */
export const AudioServicesProvider: React.FC<AudioServicesProviderProps> = ({ value, children }) => (
  <AudioServicesContext.Provider value={value}>{children}</AudioServicesContext.Provider>
);
